export const roomRateAvailabilityStatuses = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  HOTEL_CLOSED: 'hotel_closed',
  CHECK_IN_CLOSED: 'check_in_closed',
};

export const DATE_FORMAT = 'ddd, D MMM';
export const XS_DATE_FORMAT = 'D MMM';
